// Onboarding Region step (ENG-554, AUTH-554): the interface and document
// languages, and the country list named and sorted in the language chosen.
// The closed currency and time-zone lists live in OnboardingPage (ENG-105).

export const LANGUAGES = ['en', 'ar'];
export const DOCUMENT_LANGUAGES = ['en', 'ar', 'ar-en'];

// Names of the languages, each in its own script so anyone can find theirs.
export const LANGUAGE_NAMES = { en: 'English', ar: 'العربية', 'ar-en': 'العربية + English' };

// [{ code, name, ... }] for the given countries, named in ``locale`` and
// sorted by that locale's own collation, not by the English spelling.
export function localisedCountries(countries, locale = 'en') {
  let names = null;
  try { names = new Intl.DisplayNames([locale], { type: 'region' }); } catch { names = null; }
  const collator = new Intl.Collator(locale);
  return countries
    .map((c) => ({ ...c, name: names?.of(c.code) || c.name }))
    .sort((a, b) => collator.compare(a.name, b.name));
}
